import type { StarterDashboardV2RootPageDataQuery } from '../rootPageData.graphql';

import { getPetitionDaysAfterPublish } from './getPetitionDaysAfterPublish';
import { getPetitionShareVisuals } from './getPetitionShareVisuals';
import { getPetitionStrengthScore } from './getPetitionStrengthScore';

export function getPetitionMetadata(petition: NonNullable<StarterDashboardV2RootPageDataQuery['petition']>) {
	return {
		daysAfterPublish: getPetitionDaysAfterPublish(petition),
		score: getPetitionStrengthScore(petition),
		shareVisuals: getPetitionShareVisuals(petition),
	};
}
